<template>
    <div class="certs">
        <h1 class="certs-title">
            <span>{{ pageH1 }}</span>
        </h1>
        <div class="certs-input">
            <div class="certs-input-title">
                Введите ИНН компании:
            </div>
            <div class="certs-input-elem">
                <input class="certs-input-elem-input" placeholder="Ваш ИНН" type="number" v-model="inn">
            </div>
            <button class="certs-input-button" @click="checkData">Найти</button>
        </div>

        <div class="certs-error" v-if="errorIf">
            {{ error }}
        </div>

        <div class="certs-data" v-if="data">
            <div class="certs-data-inn">
                ИНН: {{ data.inn }}
            </div>
            <div class="certs-data-name">
                Наименование компании: {{ data.name }}
            </div>
        </div>

        <div class="certs-qr" v-if="data">
            <div class="certs-qr-title">
                Сертификат по <span><a style="color: blue; font-weight: 600;" :href="`/certs-check?inn=${inn}`">ссылке</a></span>:
            </div>
            <VueQRCodeComponent :text="valueQr" :size="size" level="H" />
        </div>
        
        <button class="certs-clear-content" style="width: fit-content; border: none; background: transparent; cursor: pointer; margin-top: 15px;"
            @click="inn = null, data=null, error='', errorIf=false"
            v-if="inn != null"
            aria-label="Сбросить поиск"
        >
            Сбросить поиск
        </button>
    </div>
</template>

<script>
import '@/assets/styles/certs.sass';
import { fetchCertificate } from '../api/adminBrands'

import VueQRCodeComponent from 'vue-qrcode-component'
import { metaFromSeoOrDefaults } from '../seo/metaFromStore'

export default {
  name: 'certs',
  data() {
    return {
        inn: null,
        data: null,
        valueQr: null,
        size: 200,
        errorIf: false,
        error: '',
    }
  },
  components: {
    VueQRCodeComponent,
  },
  computed: {
    pageH1() {
      const s = this.$store.state.seoPage
      if (s && s.id && s.h1) {
        return s.h1
      }
      return 'Проверка наличия сертификата дистрибьютора'
    },
  },
  methods: {
    async checkData() {
        try {
            const response = await fetchCertificate(this.inn)
            if (!response.data || response.data.length <= 0) {
                this.data = null;
                this.errorIf = true;
                this.error = 'Дистрибьютор по заданному ИНН не найден. Проверьте данные на корректность или обратитесь за помощью любым удобным для вас способом.'
            } else {
                this.errorIf = false;
                this.error = '';
                this.data = response.data[0];
                this.valueQr = window.location.protocol + '//' + window.location.host + window.location.pathname + '-check' + '?inn=' + this.inn;
            }
        } catch (e) {
            this.data = null;
            this.errorIf = true;
            this.error = 'Дистрибьютор по заданному ИНН не найден. Проверьте данные на корректность или обратитесь за помощью любым удобным для вас способом.'
        }
    }
  },
  metaInfo() {
    return metaFromSeoOrDefaults(this.$store, {
      title: 'Проверить сертификат по ИНН',
    })
  },
  watch: {
    inn(newInn) {
        if(newInn === null || newInn === '') {
            this.data = null;
        }
    }
  }
}

</script>

